import type { HeroImageBlock as HeroImageBlockType } from '@/shared/types/blocks';
import { ContentPreview } from '@/shared/ui/content-preview';

export function HeroImageBlock({
  src,
  overlayText,
  height,
}: Omit<HeroImageBlockType, 'type' | 'id'>) {
  return (
    <ContentPreview
      backgroundImage={src || ''}
      overlayText={overlayText || ''}
      height={height || 240}
    />
  );
}
